/*
 * Birthing Love - the fourth journey: a light is born from the mother's womb
 * on the Prenatal card, drifts down into the footer and comes to rest as the
 * bindu of a Shri Yantra.
 *
 * HOW THE YANTRA FORMS. The whole figure - bhupura, circles, both lotus rings
 * and the nine triangles - appears together as a field of fine dots as it
 * scrolls into view. As you keep scrolling the dots lengthen and close up,
 * and the lines become whole exactly when the page reaches its end (the
 * bottom of the footer meets the bottom of the screen).
 *
 * The dots are a dash pattern sized in real screen pixels (worked out from
 * the yantra's size on screen), so they look the same in every browser.
 *
 * WHERE THE LIGHT IS BORN: a point on the Prenatal card (the SECOND card,
 * found by its place in the row) given as fractions of the card's width and
 * height (START_X, START_Y) - her belly.
 *
 * PHONES: the light runs on phones too. Its drawing box clips sideways so it
 * can never make a narrow page scroll sideways.
 *
 * WHEN IT TRAVELS. The light leaves her belly when the card is a little below
 * the middle of the screen (BORN) and travels down with the page, arriving as
 * the yantra's centre settles at LAND - however much lies in between (e.g. the
 * Real stories section). So it is always born where you can see it.
 *
 * BEHIND THE GLASS. Anything marked data-br-light-behind (the story cards) is
 * cut out of the light with a mask, so the light passes behind the frosted
 * cards and shows only faintly through them; data-br-light-clip on a scrolling
 * row limits each cut-out to the part of the card that is on show. Anything
 * marked data-br-light-soft (headings, links) dims the light softly as it
 * passes behind the words.
 *
 * SMOOTHNESS. The light glides: each frame it moves part of the way towards
 * where the scroll says it should be (GLIDE), so uneven or fast scrolling
 * never makes it jump. Its soft glow is two plain tapered shapes (a wide
 * faint one under a narrower one) rather than an SVG blur, and the soft
 * cut-outs behind headings use a soft-edged gradient rather than a blur -
 * both used to be redrawn over the whole length of the light on every
 * frame. The guide curve is measured once into a table of points. Each
 * frame measures everything first and draws afterwards, and nothing is
 * redrawn unless it has actually changed.
 */
(function () {
  'use strict';
  if (window.__brYantraInit) return;
  window.__brYantraInit = true;

  var START_X = 0.30;
  var START_Y = 0.72;
  var LINE_PX = 1.2;   /* line thickness on screen */
  var DOT_PX = 1.1;    /* dot length at the start, on screen */
  var PERIOD_PX = 6.5; /* dot + gap at the start, on screen */
  var BORN = 0.62;     /* the light leaves the card when her belly is this far down the screen */
  var LAND = 0.58;     /* ... and settles as the yantra's centre reaches this far down */
  var GLIDE = 90;      /* ms - how softly the light follows the scroll */
  var SAMPLES = 40;    /* points along the light's tail */

  var NS = 'http://www.w3.org/2000/svg';
  var cl = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var sine = function (t) { return -(Math.cos(Math.PI * t) - 1) / 2; };
  var eo = function (t) { return 1 - Math.pow(1 - t, 3); };
  var f = function (n) { return (Math.round(n * 1000) / 1000).toString(); };

  function P(r, a) { return [r * Math.sin(a), -r * Math.cos(a)]; }

  function scroller(from) {
    var e = from && from.parentElement;
    while (e && e !== document.body && e !== document.documentElement) {
      var oy = getComputedStyle(e).overflowY;
      if (oy === 'auto' || oy === 'scroll') return e;
      e = e.parentElement;
    }
    return null;
  }

  function start() {
    var svg = document.querySelector('[data-br-yantra]');
    if (!svg || svg.getAttribute('data-built')) return;
    svg.setAttribute('data-built', '1');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var colour = svg.getAttribute('data-color') || '#F6E7C4';
    var strength = (parseFloat(svg.getAttribute('data-strength')) || 72) / 100;
    var trailOn = svg.getAttribute('data-trail') !== 'false';
    var foot = svg.closest('[data-br-foot-section]');
    var VB = 4.6;
    svg.setAttribute('viewBox', '-2.3 -2.3 4.6 4.6');

    svg.innerHTML =
      '<defs>' +
        '<filter id="brYnGlow" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation=".012" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>' +
        '<radialGradient id="brYnHalo"><stop offset="0%" stop-color="#FFF8E8" stop-opacity=".95"/><stop offset="35%" stop-color="#FFE9BE" stop-opacity=".4"/><stop offset="100%" stop-color="#FFE0A8" stop-opacity="0"/></radialGradient>' +
      '</defs>';
    var g = document.createElementNS(NS, 'g');
    g.setAttribute('fill', 'none');
    g.setAttribute('stroke', colour);
    g.setAttribute('stroke-linejoin', 'round');
    g.setAttribute('stroke-linecap', 'round');
    g.setAttribute('filter', 'url(#brYnGlow)');
    g.setAttribute('opacity', '0');
    svg.appendChild(g);

    var lines = [];
    function line(d, w) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      g.appendChild(p);
      lines.push({ el: p, w: w || 1 });
    }
    function circle(r) {
      return 'M0,' + f(-r) + ' A' + f(r) + ',' + f(r) + ' 0 1 1 0,' + f(r) + ' A' + f(r) + ',' + f(r) + ' 0 1 1 0,' + f(-r);
    }

    /* 1. bhupura */
    function rot4(side) {
      var pts = [];
      for (var k = 0; k < 4; k++) {
        var c = Math.cos(k * Math.PI / 2), s = Math.sin(k * Math.PI / 2);
        for (var i = 0; i < side.length; i++) {
          var x = side[i][0], y = side[i][1];
          pts.push([x * c - y * s, x * s + y * c]);
        }
      }
      return 'M' + pts.map(function (p) { return f(p[0]) + ',' + f(p[1]); }).join(' L') + ' Z';
    }
    var Q = 1.82, ins = 0.055 * Q;
    var outerSide = [[-Q, -Q], [-.68 * Q, -Q], [-.68 * Q, -1.2 * Q], [.68 * Q, -1.2 * Q], [.68 * Q, -Q]];
    var innerSide = [[-Q + ins, -Q + ins], [-.30 * Q, -Q + ins], [-.30 * Q, -1.07 * Q], [-.68 * Q + ins, -1.07 * Q], [-.68 * Q + ins, -1.2 * Q + ins],
                     [.68 * Q - ins, -1.2 * Q + ins], [.68 * Q - ins, -1.07 * Q], [.30 * Q, -1.07 * Q], [.30 * Q, -Q + ins]];
    line(rot4(outerSide), 1.05);
    line(rot4(innerSide), .8);

    /* 2. three circles */
    line(circle(1.70));
    line(circle(1.66), .7);
    line(circle(1.62));

    /* 3 & 4. lotus rings */
    function lotus(n, r1, r2) {
      var da = Math.PI / n, d = '';
      for (var i = 0; i < n; i++) {
        var a = i * 2 * da;
        var b1 = P(r1, a - da * .98), tip = P(r2, a), b2 = P(r1, a + da * .98);
        var c1 = P(r1 + (r2 - r1) * .62, a - da * 1.05), c2 = P(r1 + (r2 - r1) * .62, a + da * 1.05);
        var c1b = P(r1 + (r2 - r1) * .9, a - da * .25), c2b = P(r1 + (r2 - r1) * .9, a + da * .25);
        d += (i ? ' L' : 'M') + f(b1[0]) + ',' + f(b1[1]) +
          ' C' + f(c1[0]) + ',' + f(c1[1]) + ' ' + f(c1b[0]) + ',' + f(c1b[1]) + ' ' + f(tip[0]) + ',' + f(tip[1]) +
          ' C' + f(c2b[0]) + ',' + f(c2b[1]) + ' ' + f(c2[0]) + ',' + f(c2[1]) + ' ' + f(b2[0]) + ',' + f(b2[1]);
      }
      return d;
    }
    line(lotus(16, 1.36, 1.60));
    line(circle(1.36), .7);
    line(lotus(8, 1.02, 1.34));

    /* 5. inner circle */
    line(circle(1.0));

    /* 6. nine interlocking triangles, measured from the reference */
    var downs = [[.273, -1.0, .97], [.716, -.237, .58], [.472, -.688, .69], [.162, -.469, .32], [.052, -.237, .26]];
    var ups = [[-.242, 1.0, .97], [-.477, .716, .72], [-.688, .472, .50], [-.095, .273, .29]];
    function tri(b, a, w) {
      return 'M' + f(-w) + ',' + f(-b) + ' L' + f(w) + ',' + f(-b) + ' L0,' + f(-a) + ' Z';
    }
    downs.concat(ups).forEach(function (t) { line(tri(t[0], t[1], t[2]), .95); });

    /* 7. bindu */
    var halo = document.createElementNS(NS, 'circle');
    halo.setAttribute('r', '.3'); halo.setAttribute('fill', 'url(#brYnHalo)'); halo.setAttribute('opacity', '0');
    svg.appendChild(halo);
    var bindu = document.createElementNS(NS, 'circle');
    bindu.setAttribute('r', '.04'); bindu.setAttribute('fill', '#FFF8E8'); bindu.setAttribute('opacity', '0');
    svg.appendChild(bindu);

    /* ---- dots -> whole lines ---- */
    var unit = VB / 320, lastW = -1, lastS = -1;
    function sizeLines(wpx) {
      wpx = wpx || svg.getBoundingClientRect().width || 320;
      if (Math.abs(wpx - lastW) < 1) return;
      lastW = wpx;
      unit = VB / wpx;
      for (var i = 0; i < lines.length; i++) {
        lines[i].el.setAttribute('stroke-width', (LINE_PX * lines[i].w * unit).toFixed(4));
      }
      lastS = -1;
    }
    /* s = 0: fine dots;  s = 1: whole lines */
    function setSolid(s) {
      s = Math.round(s * 200) / 200;
      if (s === lastS) return;
      lastS = s;
      if (s >= 1) {
        for (var i = 0; i < lines.length; i++) lines[i].el.removeAttribute('stroke-dasharray');
        return;
      }
      var dash = (DOT_PX + (PERIOD_PX - DOT_PX) * s) * unit;
      var gap = (PERIOD_PX - DOT_PX) * (1 - s) * unit;
      var da = dash.toFixed(4) + ' ' + Math.max(gap, 0.0001).toFixed(4);
      for (var j = 0; j < lines.length; j++) lines[j].el.setAttribute('stroke-dasharray', da);
    }
    sizeLines();

    if (reduce) {
      g.setAttribute('opacity', strength);
      setSolid(1);
      bindu.setAttribute('opacity', '1'); halo.setAttribute('opacity', '.6');
      return;
    }
    setSolid(0);

    /* ---- the travelling light ---- */
    var host = document.createElement('div');
    host.setAttribute('aria-hidden', 'true');
    host.style.cssText = 'position:relative;height:0;width:100%;overflow-x:clip;overflow-y:visible;pointer-events:none;margin:0;padding:0';
    var layer = document.createElement('div');
    layer.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:1px;pointer-events:none;z-index:6;overflow:visible;will-change:transform';
    layer.innerHTML =
      '<svg width="100%" height="100%" style="overflow:visible;display:block">' +
        '<defs>' +
        '<radialGradient id="brYtSoftG"><stop offset="0%" stop-color="#161616"/><stop offset="55%" stop-color="#161616"/><stop offset="100%" stop-color="#161616" stop-opacity="0"/></radialGradient>' +
        '<radialGradient id="brYtHalo"><stop offset="0%" stop-color="#FFF8E8" stop-opacity=".95"/><stop offset="35%" stop-color="#FFE9BE" stop-opacity=".45"/><stop offset="100%" stop-color="#FFE0A8" stop-opacity="0"/></radialGradient>' +
        '<mask id="brYtMask" maskUnits="userSpaceOnUse" x="0" y="0" width="1" height="1">' +
          '<rect id="brYtMaskRect" x="0" y="0" width="1" height="1" fill="#fff"/>' +
          '<g id="brYtHoles" fill="#2b2b2b"></g>' +
          '<g id="brYtSoftHoles" fill="url(#brYtSoftG)"></g>' +
        '</mask></defs>' +
        '<g id="brYtShift">' +
          '<path id="brYtGuide" fill="none" stroke="none"/>' +
          '<g id="brYtLight" mask="url(#brYtMask)">' +
            '<path id="brYtGlowWide" fill="' + colour + '" opacity="0"/>' +
            '<path id="brYtGlow" fill="' + colour + '" opacity="0"/>' +
            '<path id="brYtCore" fill="' + colour + '" opacity="0"/>' +
            '<g id="brYtStar" opacity="0"><circle r="28" fill="url(#brYtHalo)"/><path fill="#FFF8E8" d="M0,-11 C1,-3.2 3.2,-1 11,0 C3.2,1 1,3.2 0,11 C-1,3.2 -3.2,1 -11,0 C-3.2,-1 -1,-3.2 0,-11 Z"/></g>' +
          '</g>' +
        '</g>' +
      '</svg>';
    host.appendChild(layer);
    var shiftEl = layer.querySelector('#brYtShift');
    var guide = layer.querySelector('#brYtGuide');
    var glowEl = layer.querySelector('#brYtGlow');
    var glowWideEl = layer.querySelector('#brYtGlowWide');
    var coreEl = layer.querySelector('#brYtCore');
    var starEl = layer.querySelector('#brYtStar');
    var holesEl = layer.querySelector('#brYtHoles');
    var softHolesEl = layer.querySelector('#brYtSoftHoles');
    var maskEl = layer.querySelector('#brYtMask');
    var maskRect = layer.querySelector('#brYtMaskRect');
    var hostParent = null;
    var lastKey = '', L = 1, PAD = 160;
    var cardEl = null, spanD = 0, cardRect = null;

    /* ---- cut-outs: the light passes behind the glass cards ---- */
    var behind = [], softs = [], rescan = 0, lastHoles = null, lastSoft = null;
    function scanHoles() {
      behind = Array.prototype.slice.call(document.querySelectorAll('[data-br-light-behind]'));
      softs = Array.prototype.slice.call(document.querySelectorAll('[data-br-light-soft]'));
    }
    function holeRects(list, hr, soft) {
      var out = '';
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        if (!el.isConnected) continue;
        var r = el.getBoundingClientRect();
        var x1 = r.left, y1 = r.top, x2 = r.right, y2 = r.bottom;
        var clip = el.closest('[data-br-light-clip]');
        if (clip && clip !== el) {
          var c = clip.getBoundingClientRect();
          x1 = Math.max(x1, c.left); x2 = Math.min(x2, c.right);
          y1 = Math.max(y1, c.top); y2 = Math.min(y2, c.bottom);
        }
        if (x2 - x1 < 2 || y2 - y1 < 2) continue;
        var rad = 14, pad = 0;
        if (soft) {
          pad = 26;
        } else {
          if (el.__brRadW !== window.innerWidth) {
            el.__brRad = parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0;
            el.__brRadW = window.innerWidth;
          }
          rad = el.__brRad;
        }
        out += '<rect x="' + (x1 - hr.left - pad).toFixed(1) + '" y="' + (y1 - hr.top - pad).toFixed(1) +
          '" width="' + (x2 - x1 + pad * 2).toFixed(1) + '" height="' + (y2 - y1 + pad * 2).toFixed(1) +
          '" rx="' + rad.toFixed(1) + '"/>';
      }
      return out;
    }
    function measureHoles(hr) {
      if (--rescan <= 0) { scanHoles(); rescan = 90; }
      return [holeRects(behind, hr, false), holeRects(softs, hr, true)];
    }
    function drawHoles(h) {
      if (h[0] !== lastHoles) { lastHoles = h[0]; holesEl.innerHTML = h[0]; }
      if (h[1] !== lastSoft) { lastSoft = h[1]; softHolesEl.innerHTML = h[1]; }
    }
    function attach() {
      var p = scroller(svg) || document.body;
      if (p !== hostParent) { hostParent = p; p.appendChild(host); lastKey = ''; }
    }

    /* the guide curve as cubic segments [x0,y0,c1x,c1y,c2x,c2y,x1,y1] - kept so the
       curve can be measured in plain arithmetic instead of asking the browser for
       hundreds of points (getPointAtLength), which stalled phones each time the
       curve was re-planned */
    var segs = [];
    function guidePath(sx, sy, ex, ey) {
      var s = ey - sy, dx = ex - sx, sw = Math.min(1, window.innerWidth / 900);
      var Qp = [[sx, sy - s * .12], [sx, sy], [sx + dx * .25 - 14 * sw, sy + s * .3], [sx + dx * .75 + 18 * sw, sy + s * .64], [ex, ey], [ex, ey + s * .2]];
      var d = 'M' + Qp[1][0] + ',' + Qp[1][1];
      segs = [];
      for (var i = 1; i < Qp.length - 2; i++) {
        var p0 = Qp[i - 1], p1 = Qp[i], p2 = Qp[i + 1], p3 = Qp[i + 2];
        var c1x = p1[0] + (p2[0] - p0[0]) / 6, c1y = p1[1] + (p2[1] - p0[1]) / 6;
        var c2x = p2[0] - (p3[0] - p1[0]) / 6, c2y = p2[1] - (p3[1] - p1[1]) / 6;
        segs.push([p1[0], p1[1], c1x, c1y, c2x, c2y, p2[0], p2[1]]);
        d += ' C' + c1x.toFixed(1) + ',' + c1y.toFixed(1) +
          ' ' + c2x.toFixed(1) + ',' + c2y.toFixed(1) +
          ' ' + p2[0].toFixed(1) + ',' + p2[1].toFixed(1);
      }
      return d;
    }

    var cardList = null, cardScan = 0, hostRect = null, lastXY = null;
    function layoutGuide(yr) {
      if (!cardList || --cardScan <= 0) { cardList = document.querySelectorAll('[data-br-root-card]'); cardScan = 120; }
      var card = cardList[1] || cardList[0];
      if (!card || !card.isConnected) { cardList = null; return false; }
      var hr = host.getBoundingClientRect(), c = card.getBoundingClientRect(), y = yr || svg.getBoundingClientRect();
      hostRect = hr; cardRect = c;
      var sx = Math.round(c.left + c.width * START_X - hr.left), sy = Math.round(c.top + c.height * START_Y - hr.top);
      var ex = Math.round(y.left + y.width / 2 - hr.left), ey = Math.round(y.top + y.height / 2 - hr.top);
      cardEl = card;
      spanD = ey - sy;
      if (ey - sy < 60) return false;
      /* re-plan only when something has really moved (cards rising into view
         shift by a few pixels every frame, and re-planning each frame stuttered) */
      var key = sx + ',' + sy + ',' + ex + ',' + ey;
      var moved = !lastXY || Math.abs(sx - lastXY[0]) > 4 || Math.abs(sy - lastXY[1]) > 4 || Math.abs(ex - lastXY[2]) > 4 || Math.abs(ey - lastXY[3]) > 4;
      if (lastKey === '' || moved) {
        lastKey = key; lastXY = [sx, sy, ex, ey];
        layer.style.top = (sy - PAD) + 'px';
        layer.style.height = (ey - sy + PAD * 2) + 'px';
        shiftEl.setAttribute('transform', 'translate(0,' + (PAD - sy) + ')');
        guide.setAttribute('d', guidePath(sx, sy, ex, ey));
        measure();
      }
      return true;
    }

    /* the guide curve, measured once into a table of points */
    var lut = null, lutN = 0, lutStep = 1;
    function measure() {
      /* walk the curve finely, then resample at even steps along its length */
      var xs = [], ys = [], acc = [0], tot = 0, STEPS = 120;
      for (var k = 0; k < segs.length; k++) {
        var q = segs[k];
        for (var j = (k ? 1 : 0); j <= STEPS; j++) {
          var t = j / STEPS, mt = 1 - t;
          var a = mt * mt * mt, b = 3 * mt * mt * t, c = 3 * mt * t * t, e = t * t * t;
          var x = a * q[0] + b * q[2] + c * q[4] + e * q[6];
          var y = a * q[1] + b * q[3] + c * q[5] + e * q[7];
          if (xs.length) { tot += Math.hypot(x - xs[xs.length - 1], y - ys[ys.length - 1]); acc.push(tot); }
          xs.push(x); ys.push(y);
        }
      }
      L = tot || 1;
      lutN = Math.max(64, Math.min(1200, Math.round(L / 3)));
      lutStep = L / lutN;
      lut = new Float32Array((lutN + 1) * 2);
      var m = 0;
      for (var i = 0; i <= lutN; i++) {
        var want = i * lutStep;
        while (m < acc.length - 2 && acc[m + 1] < want) m++;
        var span = Math.max(acc[m + 1] - acc[m], 1e-6), u = cl((want - acc[m]) / span, 0, 1);
        lut[i * 2] = xs[m] + (xs[m + 1] - xs[m]) * u;
        lut[i * 2 + 1] = ys[m] + (ys[m + 1] - ys[m]) * u;
      }
    }
    /* the mask covers only the light as it is now (its tail, head and halo),
       so each frame the browser repaints that small area and nothing more */
    var lastMask = '';
    function fitMask(a, b) {
      var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
      for (var i = 0; i <= 16; i++) {
        var q = ptAt(a + (b - a) * i / 16);
        if (q.x < x0) x0 = q.x; if (q.x > x1) x1 = q.x;
        if (q.y < y0) y0 = q.y; if (q.y > y1) y1 = q.y;
      }
      var M = 48;
      var v = [Math.floor(x0 - M), Math.floor(y0 - M), Math.ceil(x1 - x0 + M * 2), Math.ceil(y1 - y0 + M * 2)];
      var k = v.join(',');
      if (k === lastMask) return;
      lastMask = k;
      var n = ['x', 'y', 'width', 'height'];
      for (var j = 0; j < 4; j++) { maskEl.setAttribute(n[j], v[j]); maskRect.setAttribute(n[j], v[j]); }
    }
    function ptAt(d) {
      var f = cl(d, 0, L) / lutStep, i = Math.min(Math.floor(f), lutN - 1), u = f - i;
      return { x: lut[i * 2] + (lut[i * 2 + 2] - lut[i * 2]) * u, y: lut[i * 2 + 1] + (lut[i * 2 + 3] - lut[i * 2 + 1]) * u };
    }

    function comet(a, b, wHead) {
      if (b - a < 1) return '';
      var Lf = [], Rt = [], N = SAMPLES, prev = null;
      for (var i = 0; i <= N; i++) {
        var u = i / N, p = ptAt(a + (b - a) * u), q = ptAt(Math.min(a + (b - a) * u + 1.5, L));
        var dx = q.x - p.x, dy = q.y - p.y;
        if (Math.abs(dx) + Math.abs(dy) < .01 && prev) { dx = prev[0]; dy = prev[1]; }
        prev = [dx, dy];
        var l = Math.hypot(dx, dy) || 1, nx = -dy / l, ny = dx / l, w = wHead * Math.pow(u, 1.6) / 2;
        Lf.push((p.x + nx * w).toFixed(1) + ',' + (p.y + ny * w).toFixed(1));
        Rt.unshift((p.x - nx * w).toFixed(1) + ',' + (p.y - ny * w).toFixed(1));
      }
      return 'M' + Lf.join(' L') + ' L' + Rt.join(' L') + ' Z';
    }

    var trailWas = false, lastOp = -1, gS = null, lastT = 0, lastDraw = '', lastRest = -1;
    function tick(now) {
      /* 1. measure - nothing is drawn until every measurement is taken */
      var H = document.documentElement.clientHeight || window.innerHeight;
      var r = svg.getBoundingClientRect();
      var yc = r.top + r.height / 2;
      var fb = foot ? foot.getBoundingClientRect().bottom : 0;
      var useTrail = trailOn;
      var hasPath = false, holes = null;
      var gl = cl((H * 1.45 - yc) / (H * 0.87), 0, 1);
      if (useTrail) {
        attach();
        hasPath = layoutGuide(r);
        if (hasPath && cardRect) {
          /* born on the card at BORN, settled at LAND (see WHEN IT TRAVELS) */
          gl = cl((H * BORN - (cardRect.top + cardRect.height * START_Y)) / (H * (BORN - LAND) + spanD), 0, 1);
        }
      }

      /* 2. glide towards where the scroll says the light should be */
      var dt = lastT ? Math.min(now - lastT, 100) : 16;
      lastT = now;
      if (gS === null) gS = gl;
      else {
        gS += (gl - gS) * (1 - Math.exp(-dt / GLIDE));
        if (Math.abs(gl - gS) < 0.0004) gS = gl;
      }
      var showTrail = useTrail && hasPath && gS > 0 && gS < 1;
      if (showTrail) holes = measureHoles(hostRect);

      /* 3. draw */
      sizeLines(r.width);
      /* appear: the whole dotted figure fades in together as it rises into view */
      var appear = eo(cl((H * 1.08 - yc) / (H * 0.3), 0, 1));
      var op = Math.round(strength * appear * 200) / 200;
      if (op !== lastOp) { lastOp = op; g.setAttribute('opacity', op); }

      /* solidify: 0 when the yantra's centre is at the bottom of the screen,
         1 when the footer's bottom reaches the bottom of the screen (end of page) */
      var s = 0;
      if (foot) {
        var D = Math.max(fb - yc, 1);
        s = cl(1 - (fb - H - 2) / Math.max(D - 2, 1), 0, 1);
      } else {
        s = cl((H - yc) / (H * 0.6), 0, 1);
      }
      setSolid(sine(s));

      var land = cl((gS - .9) / .1, 0, 1);
      var restGlow = Math.round((useTrail ? land : appear) * 500) / 500;
      if (restGlow !== lastRest) {
        lastRest = restGlow;
        bindu.setAttribute('opacity', restGlow.toFixed(3));
        halo.setAttribute('opacity', (restGlow * .65).toFixed(3));
      }

      if (useTrail) {
        if (showTrail) {
          trailWas = true;
          drawHoles(holes);
          var d = L * sine(gS), tailD = Math.max(0, d - H * .5);
          var key = Math.round(d * 4) + ',' + Math.round(tailD * 4) + ',' + lastKey;
          if (key !== lastDraw) {
            lastDraw = key;
            fitMask(tailD, d);
            coreEl.setAttribute('d', comet(tailD, d, 2.6));
            glowEl.setAttribute('d', comet(tailD, d, 9));
            glowWideEl.setAttribute('d', comet(tailD, d, 20));
            var fade = cl(gS / .06, 0, 1) * (1 - cl((gS - .75) / .17, 0, 1));
            coreEl.setAttribute('opacity', (strength * fade).toFixed(3));
            glowEl.setAttribute('opacity', (strength * .2 * fade).toFixed(3));
            glowWideEl.setAttribute('opacity', (strength * .08 * fade).toFixed(3));
            var h = ptAt(d);
            var born = eo(cl(gS / .08, 0, 1));
            var sc = (0.35 + 0.65 * born) * (1 + .3 * Math.sin(land * Math.PI));
            starEl.setAttribute('transform', 'translate(' + h.x.toFixed(1) + ',' + h.y.toFixed(1) + ') scale(' + sc.toFixed(3) + ')');
            starEl.setAttribute('opacity', (cl(gS / .02, 0, 1) * (1 - land)).toFixed(3));
          }
        } else if (trailWas) {
          trailWas = false; lastDraw = '';
          coreEl.setAttribute('d', ''); glowEl.setAttribute('d', ''); glowWideEl.setAttribute('d', '');
          coreEl.setAttribute('opacity', '0'); glowEl.setAttribute('opacity', '0'); glowWideEl.setAttribute('opacity', '0');
          starEl.setAttribute('opacity', '0');
        }
      }
      requestAnimationFrame(tick);
    }
    var relayout = function () { lastKey = ''; lastXY = null; lastW = -1; rescan = 0; };
    window.addEventListener('resize', relayout);
    window.addEventListener('load', relayout);
    if (trailOn) attach();
    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function () { start(); });
})();
